import React from "react";
import _ from 'lodash';

import { 
    Row,
    Col,
    Form,
    Spinner,
    Button,
} from "react-bootstrap-v5";

import { DrawerContentLayout } from '../../../components/drawer/DrawerLayout'
import Utils from "../../../utils/utils";

import RSuiteSelectPicker from '../../../components/OLD/Select/RSuiteSelectPicker';
import makeBinType from "../../../components/makeCategoryCompenents/binType/makeBinType";

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet } from '../../../../setup/redux/dispatch/actions'


const BinType = makeBinType(RSuiteSelectPicker);


class BinNumbersForm extends React.Component {
  
    constructor(props) {
        super(props);
    
        this.bodyRef = React.createRef();

        let dataParams = (props.dataParams) ? props.dataParams : null;
        let id = (dataParams && dataParams.id) ? dataParams.id : null;
        let row = (dataParams && dataParams.row) ? dataParams.row : null;
        
        this.state = {
            id: id,
            row: row,
        };
    }


    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            'binnumber_form_drawer-bin_type', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = variables.items;

                if(data && data.data && data.data.length > 0) {
                    for (var i = 0; i < data.data.length; i++) {
                        let item = data.data[i];
                        let value = item.binTypeId;
                        let title = item.binTypeName;
                        let arrItem = {
                            value: value,
                            title: title,
                            item: item,
                        };

                        arr = Utils.addToArray(arr, value, arrItem);
                    }
                }

                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(arr);
                    }
                });
            }
        );
    }
	
    callReadBinTypeApi = (items, callback = null) => {
        let data = {
            currentPage: 1,
            pageSize: Utils.getMaxPageSize(),
            searchQuery: '',
        };
     
        this.props.dispatchApiCallGet(data, 'binnumber_form_drawer-bin_type', 'binType', { items: items }, callback, () => {});
    }
    /* END API */


    body = () => {
        let {
            handleChange,
            setFieldValue,
            validateForm,
            values,
            errors,
        } = this.props.formOptions;
        
        return <Row>
            
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.binNumberName.label}</Form.Label>
                    <Form.Control
                        type="text"
                        id={this.props.fields.binNumberName.id}
                        placeholder={this.props.fields.binNumberName.placeholder}
                        value={values.binNumberName}
                        onChange={async (e) => {
                            let value = e.target.value;
                            let pattern = Utils.max7chars();
    
                            if(value.match(pattern) != null){
                                await setFieldValue('binNumberName', value);
                            }
                        }}
                        isInvalid={!!errors.binNumberName}
                    />
                    <Form.Control.Feedback type="invalid">{errors.binNumberName}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.binTypeId.label}</Form.Label>
                    <Form.Control
                        as = {BinType}
                        isInvalid={!!errors.binTypeId}

                        id={this.props.fields.binTypeId.id}
                        placeholder={this.props.fields.binTypeId.placeholder}
                        items={values.customFormParams.binTypeItems}
                        value={values.binTypeId}
                        selectedName={values.binTypeName}
                        isLoading={values.customFormParams.binTypeIsLoading}
                        searchable={true}
                        cleanable={true}
                        isDefault={true}
                        onClick={async () => {
                            await setFieldValue('customFormParams.binTypeIsLoading', true);
                            this.callReadBinTypeApi(values.customFormParams.binTypeItems, async (items) => {
                                await setFieldValue('customFormParams.binTypeItems', items);
                                await setFieldValue('customFormParams.binTypeIsLoading', false);
                            });
                        }}
                        onSelect={async (value, item) => {
                            await setFieldValue('binTypeId', value);
                            await setFieldValue('binTypeName', item.title);
                        }}
                        onClear={async () => {
                            await setFieldValue('binTypeId', null);
                            await setFieldValue('binTypeName', '');
                        }}
                        onCreate={async (item) => {
                            let items = values.customFormParams.binTypeItems;
                            items.push(item)
                            await setFieldValue('customFormParams.binTypeItems', items);
                            await setFieldValue('binTypeId', item.value);
                            await setFieldValue('binTypeName', item.title);
                        }}
                        onUpdate={async (item) => {
                            let items = values.customFormParams.binTypeItems
                            let index = items.findIndex(x => x.value === item.value);
                            items[index] = item;

                            await setFieldValue('customFormParams.binTypeItems', items);
                            if(values.binTypeId === item.value){
                                await setFieldValue('binTypeId', item.value);
                                await setFieldValue('binTypeName', item.title);
                            }
                        }}
                        onRemove={async (item) => {
                            let items = values.customFormParams.binTypeItems.filter(x => x.value !== item.value);
                            await setFieldValue('customFormParams.binTypeItems', items);
                            await setFieldValue('binTypeId', null);
                            await setFieldValue('binTypeName', '');
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.binTypeId}</Form.Control.Feedback>
                </Form.Group>
            </Col>

        </Row>
    }
    
    footer = () => {
        let {
            validateForm,
            values,
        } = this.props.formOptions;

        return <Row>
            <Col xs={'auto'}>
                <Button 
                    type={'submit'}
                    disabled={this.props.isLoading}
                >
                    SAVE
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            <Col xs={'auto'}>
                <Button 
                    type={'button'}
                    variant={'secondary'}
                    disabled={this.props.isLoading}
                    onClick={() => {
                        Utils.showDrawer(this.props.drawer, false);
                    }}
                >
                    CANCEL
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            
            
            {values.isEdit && <>
                <Col xs={12} className={'d-flex d-sm-none pb-3'}></Col>
                {this.props.onDelete && <Col xs={'auto'} sm={true} className={'text-end'}>
                    <Button 
                        type={'button'}
                        variant={'danger'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            if(this.props.onDelete){
                                this.props.onDelete(values);
                            }
                        }}
                    >
                        REMOVE
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>}
                {this.props.onCopy && <Col xs={'auto'} md={'auto'}>
                    <Button 
                        type={'button'}
                        variant={'outline-secondary'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            validateForm().then((err) => {
                                if(_.isEmpty(err)){
                                    if(this.props.onCopy){
                                        this.props.onCopy(values);
                                    }
                                } else {
                                    Utils.toast('You must fill in the required fields', 'error');
                                }
                            })
                        }}
                    >
                        <i className={'material-icons'}>content_copy</i>
                        COPY
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>}
            </>}

        </Row>
    }


    render() {
        return <DrawerContentLayout
            ref={this.bodyRef}
            isBlocking={this.props.isBlocking}
            body={this.body()}
            footer={this.footer()}
        />
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(BinNumbersForm);
